// react components
import React, {
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    contentTypeDataSite,
    contentTypeModelTypeSite,
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
    reduxModalMainFormShowSite,
} from 'data'

// pages
import {
    AddButton825,
    Button825,
    ImageForm825,
} from 'pages'

// serializers
import {
    ContentTypeSettingsTypes,
} from 'serializers/site'

// props
type DetailAction825Props = {
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    defaultFieldsOnAdd?: any
    detailObject: any
    disableOrdering?: boolean
    filterParams?: string
    hasOrdering: boolean
    inModal?: boolean
    isOrdering: boolean
    parentModelField: string
    parentObject: {
        id: number
        content_type_string: string
        content_uuid: string
        model_content_type_id: number
        profile?: any
    }
    refreshData: () => void
    setIsOrdering: (value: boolean) => void
    subContentType?: any
    subContentTypes?: any
}

// main
export const DetailTabAction825: React.FC<DetailAction825Props> = React.memo(({
    contentType,
    contentTypeSettings,
    defaultFieldsOnAdd,
    detailObject,
    disableOrdering,
    filterParams,
    hasOrdering,
    inModal,
    isOrdering,
    parentModelField,
    parentObject,
    refreshData,
    setIsOrdering,
    subContentType,
    subContentTypes,
}) => {

    const dispatch = useDispatch()
    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const [isImageFormOpen, setIsImageFormOpen] = useState(false)
    const [subContentTypesIsImageForm, setSubContentTypesIsImageForm] = useState(false)

    if (!parentObject.id) return null

    const placeholderContext: Record<string, any> = {
        parentObject,
        reduxAuth,
    }
    const SINGLE_PLACEHOLDER_PATTERN = /^\{([a-zA-Z0-9_]+)\.([^}]+)\}$/
    const PLACEHOLDER_PATTERN = /\{([a-zA-Z0-9_]+)\.([^}]+)\}/g

    function getContextValue(contextKey: string, path: string) {
        try {
            const source = placeholderContext[contextKey]
            if (!source) return undefined
            return path.split('.').reduce((acc: any, key) => {
                if (acc === null || typeof acc !== 'object') return undefined
                return (acc as Record<string, any>)[key]
            }, source)
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'DetailTabAction825',
                'getContextValue',
            ))
            return undefined
        }
    }

    function resolveDefaultTemplate(template: any): any {
        try {
            if (Array.isArray(template)) {
                return template.map((item) => resolveDefaultTemplate(item))
            }
            if (template && typeof template === 'object') {
                return Object.fromEntries(
                    Object.entries(template).map(([key, value]) => [key, resolveDefaultTemplate(value)]),
                )
            }
            if (typeof template !== 'string' || !template.includes('{')) {
                return template
            }
            const wholeMatch = template.match(SINGLE_PLACEHOLDER_PATTERN)
            if (wholeMatch) {
                const value = getContextValue(wholeMatch[1], wholeMatch[2])
                return value ?? ''
            }
            PLACEHOLDER_PATTERN.lastIndex = 0
            return template.replace(PLACEHOLDER_PATTERN, (_match, contextKey, path) => {
                const value = getContextValue(contextKey, path)
                if (value === undefined || value === null) return ''
                if (typeof value === 'object') {
                    try {
                        return JSON.stringify(value)
                    } catch (error) {
                        return ''
                    }
                }
                return value
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'DetailTabAction825',
                'resolveDefaultTemplate',
            ))
            return template
        }
    }

    function onShowModalForm(subContentTypeId?: number) {
        try {
            let defaultFields = {
                [parentModelField]: parentObject,
            }
            // TODO check if dynamic possible
            if (parentModelField.includes('object_id')) {
                /// @ts-ignore
                defaultFields[parentModelField] = parentObject.id
                defaultFields['content_type'] = {
                    id: parentObject.model_content_type_id,
                    /// @ts-ignore
                    name: parentObject.content_type_string,
                }
            }
            // TODO
            if (subContentTypeId) {
                /// @ts-ignore
                defaultFields.sub_content_type = { id: subContentTypeId, name: subContentTypeId }
            } else if (subContentType) {
                defaultFields['sub_content_type'] = {
                    id: subContentType.id,
                    /// @ts-ignore
                    name: subContentType.id,
                }
            }
            if (filterParams?.includes('asset_custom_category')) {
                // @ts-ignore
                defaultFields['asset_custom_category'] = filterParams.split('&').find((param) => param.includes('asset_custom_category')).split('=')[1]
            }
            if (filterParams?.includes('attribution_category')) {
                // @ts-ignore
                defaultFields['attribution_category'] = {
                    // @ts-ignore
                    id: filterParams.split('&').find((param) => param.includes('attribution_category')).split('=')[1],
                    // @ts-ignore
                    name: filterParams.split('&').find((param) => param.includes('attribution_category')).split('=')[1],
                }
            }
            if (filterParams?.includes('module_views')) {
                // @ts-ignore
                defaultFields['module_views'] = [{
                    // @ts-ignore
                    id: filterParams.split('&').find((param) => param.includes('module_views')).split('=')[1],
                    // @ts-ignore
                    name: filterParams.split('&').find((param) => param.includes('module_views')).split('=')[1],
                }]
            }
            if (defaultFieldsOnAdd) {
                const resolvedDefaultFields = resolveDefaultTemplate(defaultFieldsOnAdd)
                // @ts-ignore
                defaultFields = {
                    ...defaultFields,
                    ...resolvedDefaultFields,
                }
            }
            console.log('defaultFields', defaultFields)
            dispatch(reduxModalMainFormShowSite({
                contentType,
                contentTypeSettings,
                defaultFields,
                objectId: 'new',
                profileObject: parentObject.profile,
                refreshData,
            }))
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'DetailTabAction825',
                'onShowModalForm',
            ))
        }
    }

    return (
        <div className='detail-tab-action-825 DetailTabAction825'>
            {hasOrdering && (
                <Button825
                    disabled={disableOrdering}
                    edit={false}
                    onClick={() => setIsOrdering(!isOrdering)}
                    padding='0 10px 0 0'
                    size='x-small'
                    text={!isOrdering ? reduxText[10196] : reduxText[10197]}
                />
            )}
            {!contentTypeSettings.meta.disableFormAdd && (
                <AddButton825
                    inModal={inModal}
                    onShowModalForm={(subContentTypeId?: number, isImage?: boolean) => {  // TODO dynamic
                        if (subContentTypeId) {
                            if (isImage) {
                                // @ts-ignore
                                setSubContentTypesIsImageForm({ id: subContentTypeId, name: subContentTypeId })
                            } else {
                                onShowModalForm(subContentTypeId)
                            }
                        } else if (subContentType) {
                            if (subContentType.isImage) {
                                setIsImageFormOpen(true)
                            } else {
                                onShowModalForm()
                            }
                        } else if ([contentTypeDataSite['datapool_asset'], contentTypeDataSite['staff_staffmessageimage']].includes(contentTypeSettings.meta.model_content_type_id)) {
                            setIsImageFormOpen(true)
                        } else {
                            onShowModalForm()
                        }
                    }}
                    size='x-small'
                    subContentTypes={subContentTypes}
                />
            )}
            {isImageFormOpen && (
                <ImageForm825
                    contentType={contentType}
                    detailObject={detailObject}
                    filterParams={filterParams}
                    refreshData={refreshData}
                    setIsOpen={setIsImageFormOpen}
                    subContentType={subContentType}
                />
            )}
            {subContentTypesIsImageForm && (
                <ImageForm825
                    contentType={contentType}
                    detailObject={detailObject}
                    filterParams={filterParams}
                    refreshData={refreshData}
                    setIsOpen={setSubContentTypesIsImageForm}
                    subContentType={subContentTypesIsImageForm}
                />
            )}
        </div>
    )
})
